module.exports = __webpack_public_path__ + "static/media/todo.b489a4de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/todo.png
// module id = 282
// module chunks = 1